import { BaseMapper } from '@ps/utils';
import {
  SegmentParentDto,
  SupplierSegmentationResponseDto,
} from '../dtos/supplier-segmentation.dto';
import {
  SegmentParent,
  SupplierSegmentation,
} from '../../models/segment-parent.model';

export class SegmentParentMapper extends BaseMapper<
  SegmentParentDto,
  SegmentParent
> {
  public fromDto({ id, name, locales }: SegmentParentDto): SegmentParent {
    return { id, name, locales };
  }

  public fromResponseDto(
    dto: SupplierSegmentationResponseDto,
  ): SupplierSegmentation {
    return {
      allParents: this.fromDtoList(dto.segmentParent),
      selectedParents: this.fromDtoList(dto.selectedSegmentParents),
    };
  }
}
